import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Sessions } from 'pages/Sessions/Sessions';
import { Merge } from 'pages/Merge/Merge';
import { Edit } from 'pages/Verify/Edit';
import { SearchResults } from './pages/SearchResults/SearchResults';
import { SessionSettings } from 'pages/SessionSettings/SessionSettings';

export const routes = (
  <Switch>
    <Route exact path='/' component={Sessions} />
    <Route exact path='/merge/sessionId/:sessionId' component={Merge} />
    <Route exact path='/edit/sessionId/:sessionId' component={Edit} />
    <Route exact path='/settings/sessionId/:sessionId' component={SessionSettings} />
    <Route path='/search/teamId/:teamId/date/:date' component={SearchResults} />
  </Switch>
);
